<template>
  <v-app>
    <Menu v-if="this.$router.currentRoute.name != 'Login'"></Menu>
     <v-main>
        <router-view  :key="$route.fullPath" />
    </v-main>
  </v-app>
</template>

<script>
import Menu from "@/components/menu/Menu";

export default {
  name: "App",
  components: {
    Menu,
  },
  data: () => {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss">
html {
  overflow-y: auto !important;
}
</style>
